import { MongoObservable } from "meteor-rxjs";
import { Project } from "../models";

export const Projects = new MongoObservable.Collection<Project>("projects", { connection: null });
Meteor.startup(() => {
if (Meteor.isServer) {
    Projects.collection._ensureIndex({creatorId: 1});
    Projects.collection._ensureIndex({companyId: 1});
    Projects.collection._ensureIndex({memberIds: 1});
    Projects.collection._ensureIndex({pmIds: 1});
    Projects.collection._ensureIndex({updaterIds: 1});
    Projects.collection._ensureIndex({currentUpdateId: 1});
}
});



// WEBPACK FOOTER //
// ./src/api/server/collections/projects.ts